import script from "./json-function.vue?vue&type=script&lang=js"
export * from "./json-function.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/extra/VabJsonViewer/types/json-function.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "144d653e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('144d653e', __exports__)) {
    console.log('reload')
    api.reload('144d653e', __exports__)
  }
  
}


export default __exports__